import { computed, ref, type Ref } from 'vue'
import type { TaskProgress } from '@haskoning/vue-speckle'

export function useOpengroundImportProgress(
  exportProgress: Ref<TaskProgress>,
  importProgress: Ref<TaskProgress>
) {
  const currentStage = ref(0)

  const exportPercent = computed(() =>
    currentStage.value >= 2 ? 100 : exportProgress.value.percent ?? 0
  )
  const importPercent = computed(() => importProgress.value.percent ?? 0)
  const importIndeterminate = computed(
    () => currentStage.value === 2 && importProgress.value.percent === null
  )
  const exportMessage = computed(() => {
    const detail = exportProgress.value.message ? `: ${exportProgress.value.message}` : ''
    return `Exporting to Speckle${detail}`
  })
  const importMessage = computed(() => {
    const detail = importProgress.value.message ? `: ${importProgress.value.message}` : ''
    return `Importing to GeoProfile${detail}`
  })

  return {
    currentStage,
    exportPercent,
    importPercent,
    importIndeterminate,
    exportMessage,
    importMessage
  }
}
